export default "__VITE_ASSET__CiCz5k1R__"